<template>
  <div class="provider-product-selector">
    <v-select :id="id" class="wabident-selector" :options="products" :value="value" @input="onInput"
      @search="searchProducts" :reduce="x => x.value" :placeholder="placeholder"></v-select>
    <label v-if="label !== ''" :for="id" class="wabident-info">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
    },
    value: {
      required: true,
    },
    label: {
      default: ''
    },
    placeholder: {
      default: 'Elige Material ...',
    },
  },
  data() {
    return {
      results: null
    }
  },
  computed: {
    products() {
      if (!this.results) {
        return [];
      }

      return this.results.map((el) => {
        return {
          label: el.name,
          value: el.id,
        };
      });
    },
    ...mapGetters(['clinic'])
  },
  methods: {
    searchProducts(search, loading) {
      loading(true);
      axios
        .get(`/clinic/${this.clinic.id}/provider_product`, {
          params: {
            search: search,
          },
        })
        .then((response) => {
          this.results = response.data.data;
        })
        .catch((error) => {
          console.log("[ERR] searchProducts:", error);
        })
        .then(() => {
          loading(false);
        });
    },
    onInput(v) {
      this.$emit('input', v);
    },
  },
  mounted() {
    const provider_product_id = Number(this.value)
    if (provider_product_id) {
      axios
        .get(`/clinic/${this.clinic.id}/provider_product/${provider_product_id}`)
        .then((response) => {
          this.results = [
            response.data
          ];
        })
        .catch((error) => {
          console.log("[ERR] searchProducts:", error);
        });
    }
  },
}
</script>
